let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gemEH")).then(() => parcelRequire('4MMPI'));